// Styles for LanguageSelector go here.
import styled from 'styled-components';
import { baseVariables, toRem, Modal } from '@marriott/mi-ui-library';

export const StyledLanguageSelector = styled.div`
  .modal-popup-container {
    @media ${baseVariables.mediaQuery.sm} {
      position: fixed;
    }
  }

  .modal-main-container {
    position: relative;
    padding-bottom: ${toRem(16)};
    @media ${baseVariables.mediaQuery.lg} {
      max-width: ${toRem(1140)};
    }
  }

  .modal-header {
    height: ${toRem(32)};
    h4 {
      color: ${baseVariables.color['base10']};
    }
    .popup-close {
      max-height: ${toRem(32)};
      max-width: ${toRem(32)};
    }
  }

  .modal-body {
    height: auto;
    max-height: calc(100vh - ${toRem(87)});
    @media ${baseVariables.mediaQuery.sm} {
      padding: ${toRem(24)} 0;
      max-height: calc(100vh - ${toRem(81)});
    }
    @media ${baseVariables.mediaQuery.md} {
      max-height: calc(100vh - ${toRem(184)});
    }
  }

  .custom-header-font h2 {
    color: ${baseVariables.color['base10']};
  }

  .custom-link a {
    color: ${baseVariables.color['base10']};
  }

  .mobile-border-2 {
    display: none;
  }
`;

// Overriding styles from linkscollection until those styles have been updated
export const StyledModalBody = styled(Modal.Body)`
  display: flex;
  flex-wrap: wrap;

  .header-international {
    margin-top: ${toRem(8)};
  }
  .custom-header-font {
    @media ${baseVariables.mediaQuery.smallMobile} {
      padding-left: ${toRem(0)};
      padding-right: ${toRem(0)};

      li {
        padding: 0;
      }
      .region-header {
        padding-left: 0 !important;
        white-space: normal;
        font-family: var(--t-base-font-family);
      }
    }
    @media ${baseVariables.mediaQuery.sm} {
      .region-header {
        padding-top: 0 !important;
      }
    }
  }
  .custom-header-font:not(:last-child) {
    @media ${baseVariables.mediaQuery.sm} {
      padding-top: 0;
      padding-bottom: 0;
      border-right: thin ${baseVariables.color['neutral30']} solid;
      padding-left: ${toRem(32)};
      padding-right: ${toRem(24)};
    }
  }

  .custom-header-font:last-child {
    @media ${baseVariables.mediaQuery.sm} {
      padding-left: ${toRem(32)};
      padding-right: ${toRem(24)};
    }
  }

  .custom-header-font:first-child {
    @media ${baseVariables.mediaQuery.sm} {
      padding-left: ${toRem(24)};
    }
  }

  .custom-header-font {
    padding-top: 0 !important;
  }
  ul {
    padding-left: 0 !important;
    margin-bottom: 0 !important;
    margin-left: ${toRem(-8)} !important;
    border-top: none !important;
    width: calc(100% + ${toRem(8)}) !important;
  }
  li {
    border-radius: ${toRem(8)};
    padding-left: ${toRem(8)} !important;
  }
  li:hover {
    background: ${baseVariables.color['neutral10']};

    a:hover {
      text-decoration: none;
    }
  }
  li a {
    min-width: -webkit-fill-available;
  }
  .t-subtitle-xl {
    font-size: 22px;
    font-style: normal;
    line-height: 125%;
    color: ${baseVariables.color['base10']};
    font-weight: 700;
    padding-top: 0 !important;
  }
`;

export const StyledModalHeader = styled(Modal.Header)`
  white-space: normal;
  @media ${baseVariables.mediaQuery.lg} {
    margin-top: ${toRem(40)};
  }
  .header-heading {
    padding-right: ${toRem(8)};
    font-family: var(--t-base-font-family);
  }
`;

export const StyledBorder = styled.div`
  border-bottom: thin ${baseVariables.color['neutral30']} solid;
  margin-top: ${toRem(24)};
  margin-bottom: ${toRem(24)};
`;
